import { FormattedMessage } from 'react-intl';

import { paymentMessages } from '@/messages/payment';

const stepPrefix = 'step';

export const Delivery = (
  <FormattedMessage
    defaultMessage='Delivery info'
    id='checkout.delivery.title'
  />
);

export const Payment = <FormattedMessage {...paymentMessages.paymentMethod} />;

export const Review = (
  <FormattedMessage
    defaultMessage='Review order'
    id='checkout.reviewOrder.reviewOrder'
  />
);

export const ReturnToTheStep = (stepNumber: number) => (
  <FormattedMessage
    defaultMessage='This operation will return to the {stepNumber} step, please confirm if you need to return to editing'
    id='checkout.modal.description.returnToStep'
    values={{
      stepNumber:
        stepNumber === 2 ? (
          <FormattedMessage
            defaultMessage='second'
            id={`${stepPrefix}.second`}
          />
        ) : (
          <FormattedMessage defaultMessage='first' id={`${stepPrefix}.first`} />
        ),
    }}
  />
);
